import MuiSwitch from "./MuiSwitch";

const Index = {
  MuiSwitch,
  MuiTableCell: {
    root: {
      fontWeight: "normal",
    },
  },
};

export default Index;
